// 收件箱 → 归属客服名映射(与 adapter INBOX_OWNER_MAP / inbox_members 对应)。
// 会话列表「频道」显示该收件箱归属的客服名,而不是收件箱名字本身。
// 新增收件箱/改归属时同步更新此处(以及 adapter config.py 的 INBOX_OWNER_MAP)。
export const inboxOwnerMap = {
  5: '张现荣',
  6: '李节恒',
  7: '杨洋',
  8: '王瑞雪',
  9: '李节恒',
};

export const inboxOwnerName = inboxId => inboxOwnerMap[inboxId] || '';
